import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { LivestreamSession } from './LivestreamSession';
import { EVENTS_I_HOST } from './SecurityRules';

export const BreakoutRoomStatusOptions = [
  { id: 'OPEN', label: 'Open' },
  { id: 'CLOSED', label: 'Closed' },
];

export interface LivestreamBreakoutRoomRow {
  id: string;
  livestream_session_id: string;
  name: string;
  livekit_room_name: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export const LivestreamBreakoutRoom: Entity<LivestreamBreakoutRoomRow> = {
  id: 'LivestreamBreakoutRoom',
  title: 'Livestream Breakout Room',
  service: 'main',
  rowLabel: (row: LivestreamBreakoutRoomRow) => row.name,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.livestream_breakout_room',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'all',
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `livestream_session_id IN (SELECT id FROM livestream_session WHERE institution_id = {adminInstitutionId})`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['name', 'ASC']],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Text,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
    },
    livestream_session_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Livestream Session',
      refEntity: LivestreamSession,
      mandatory: true,
      listColumn: true,
    },
    name: {
      seq: 15,
      type: FieldType.Text,
      label: 'Room Name',
      mandatory: true,
      listColumn: true,
    },
    livekit_room_name: {
      seq: 20,
      type: FieldType.Text,
      label: 'LiveKit Room Name',
      mandatory: true,
      listColumn: false,
    },
    status: {
      seq: 25,
      type: FieldType.Options,
      label: 'Status',
      options: BreakoutRoomStatusOptions,
      mandatory: true,
      listColumn: true,
    },
    created_at: {
      seq: 30,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    updated_at: {
      seq: 35,
      label: 'Updated At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
